exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-full-size.modal-dialog{max-width:100%;margin:0;background-color:#343a40}", ""]);

